import { axios } from '../utils/request'

export function login(paramsList) {
  return axios({
    url: '/auth/oauth/token',
    method: 'POST',
    params: paramsList
  })
}
// 退出的登陆

export function logout() {
  return axios({
    url: '/auth/token/logout',
    method: 'DELETE'
  })
}

// 用户信息

export function getLoginInfo() {
  return axios({
    url: '/admin/user/getLoginInfo',
    method: 'GET'
  })
}

// 用户信息

export function userInfo() {
  return axios({
    url: '/admin/user/info',
    method: 'GET'
  })
}

export function userInfoEdit(avatar, nickName, phone, password, newpassword1, username) {
  return axios({
    url: '/admin/user/edit',
    method: 'PUT',
    data: {
      avatar,
      nickName,
      phone,
      password,
      newpassword1,
      username
    }
  })
}

// 用户列表接口

export function userGetPage(data) {
  return axios({
    url: '/admin/user/getPage',
    method: 'POST',
    data
  })
}

// 删除用户信息接口

export function deleteUser(userId) {
  return axios({
    url: `/admin//user/deleteUser`,
    method: 'POST',
    data: {
      userId
    }
  })
}

// 添加用户接口
export function addUser(data) {
  return axios({
    url: `/admin/user`,
    method: 'POST',
    data
  })
}

// 编辑用户接口
export function editUser(data) {
  return axios({
    url: `/admin/user/edit`,
    method: 'PUT',
    data
  })
}

// 子公司列表接口

export function sysCompanyPage(data) {
  return axios({
    url: '/admin/sysCompany/page',
    method: 'POST',
    data
  })
}

// 导入功能

export function importExcel(data) {
  return axios({
    url: '/admin/user/importExcel',
    method: 'POST',
    data: data
  })
}

// 删除子公司信息接口
export function deleteSysCompany(id) {
  return axios({
    url: `/admin/sysCompany/${id}`,
    method: 'DELETE'
  })
}

// 新增子公司
export function addSysCompany(data) {
  return axios({
    url: '/admin/sysCompany',
    method: 'POST',
    data: data
  })
}

// 修改子公司
export function editSysCompany(data) {
  return axios({
    url: '/admin/sysCompany',
    method: 'PUT',
    data: data
  })
}

// 删除白名单用户信息接口
export function deleteWhitelistUser(userId, isCompanyAdminInsert) {
  return axios({
    url: `/admin//user/deleteUser`,
    method: 'POST',
    data: {
      userId,
      isCompanyAdminInsert
    }
  })
}

// 金点子列表接口

export function goldenIdeaPage(data) {
  return axios({
    url: '/admin/goldenIdea/page',
    method: 'POST',
    data
  })
}

// 获取金点子分类

export function goldenIdeaGetClassify() {
  return axios({
    url: '/admin/goldenIdea/getClassify',
    method: 'GET'
  })
}

// 获取金点子详情
export function goldenIdeaDetail(id) {
  return axios({
    url: `/admin/goldenIdea/getById`,
    method: 'GET',
    params: {
      id
    }
  })
}
// 金点子图片

export function goldenIdeaPicPage(data) {
  return axios({
    url: '/admin/goldenIdeaPic/page',
    method: 'POST',
    data
  })
}

// 删除金点子
export function deleteGoldenIdea(id) {
  return axios({
    url: `/admin/goldenIdea/${id}`,
    method: 'DELETE'
  })
}

// 金点子评论列表
export function goldenIdeaCommentPage(data) {
  return axios({
    url: '/admin/goldenIdeaComment/page',
    method: 'POST',
    data
  })
}

// 导出
export function goldenIdEaexportExcel(data) {
  return axios({
    url: '/admin/goldenIdea/exportExcel',
    method: 'POST',
    responseType: 'blob',
    data
  })
}
